var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modules-settings-tenant-detail" }, [
    _c("div", { staticClass: "nav-section" }, [
      _c(
        "a",
        {
          staticClass: "nav-back",
          on: {
            click: function ($event) {
              return _vm.navToTenantTab()
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("back")))]
      ),
    ]),
    _vm._v(" "),
    _vm.allowEdit
      ? _c("div", { staticClass: "align-right action-bar" }, [
          _vm.editView
            ? _c(
                "button",
                {
                  directives: [{ name: "hkldreset", rawName: "v-hkldreset" }],
                  staticClass: "btn btn--orange",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.discardChange()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("action.cancel")))]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.editView
            ? _c(
                "button",
                {
                  staticClass: "btn btn--orange",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.editView = true
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("action.edit")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.editView
            ? _c(
                "button",
                {
                  directives: [{ name: "hkldreset", rawName: "v-hkldreset" }],
                  staticClass: "btn btn--orange",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("action.save")))]
              )
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "tenant-number" }, [
      _c("label", { staticClass: "emphasis" }, [
        _vm._v(" " + _vm._s(_vm.$t("settings.user.tenant.number")) + ": "),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.tenantDetail.id))]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "contract-detail" }, [
      _c("label", { staticClass: "emphasis sub-title" }, [
        _vm._v(_vm._s(_vm.$t("settings.user.vendor.companyDetail"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "small-6 medium-6 large-6 columns" }, [
          _c("p", [_vm._v(_vm._s((_vm.tenantDetail || {}).name))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s((_vm.tenantDetail || {}).address1))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s((_vm.tenantDetail || {}).address2))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s((_vm.tenantDetail || {}).address3))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s((_vm.tenantDetail || {}).address4))]),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.specialHandled,
                expression: "specialHandled",
              },
              { name: "hkldinput", rawName: "v-hkldinput" },
            ],
            class: { disabled: !_vm.editView },
            attrs: {
              type: "checkbox",
              id: "settings-users-tenant-company-name-update",
              disabled: !_vm.editView,
            },
            domProps: {
              checked: Array.isArray(_vm.specialHandled)
                ? _vm._i(_vm.specialHandled, null) > -1
                : _vm.specialHandled,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.specialHandled,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.specialHandled = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.specialHandled = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.specialHandled = $$c
                }
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { attrs: { for: "settings-users-tenant-company-name-update" } },
            [_vm._v(_vm._s(_vm.$t("settings.user.vendor.combineName")))]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("label", { staticClass: "emphasis" }, [
        _vm._v(" " + _vm._s(_vm.$t("settings.user.vendor.phone"))),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s((_vm.tenantDetail || {}).phone || "--"))]),
      _vm._v(" "),
      _c("label", { staticClass: "emphasis" }, [
        _vm._v(" " + _vm._s(_vm.$t("company.contact.fax"))),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s((_vm.tenantDetail || {}).fax || "--"))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }